import { Equipment, Fai, FaiBox, Product, ProductFactory, Subscription } from '@bytel/bytel-sales';

import { EquipmentComponent } from '../tunnel/cart/equipment-block/equipment/equipment.component';
import { FaiBoxComponent } from '../tunnel/cart/equipment-block/fai-box/fai-box.component';
import { FaiComponent } from '../tunnel/cart/subscription-block/fai/fai.component';
import { SubscriptionComponent } from '../tunnel/cart/subscription-block/subscription/subscription.component';

export class ProductMapping {
    public static getComponent(product: Product): any {
        let component: any = EquipmentComponent;

        switch (true) {
            case ProductFactory.Is(product, Fai):
                component = FaiComponent;
                break;

            case ProductFactory.Is(product, FaiBox):
                component = FaiBoxComponent;
                break;

            case ProductFactory.Is(product, Subscription):
                component = SubscriptionComponent;
                break;

            case ProductFactory.Is(product, Equipment):
                component = EquipmentComponent;
                break;
        }

        return component;
    }
}
